import { render, staticRenderFns } from "./PMiniLabel.vue?vue&type=template&id=ae5d92ca&scoped=true&"
import script from "./PMiniLabel.vue?vue&type=script&lang=ts&"
export * from "./PMiniLabel.vue?vue&type=script&lang=ts&"
import style0 from "./PMiniLabel.vue?vue&type=style&index=0&id=ae5d92ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5d92ca",
  null
  
)

export default component.exports